import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  styleUrls: ['../../global-styles.less', './tellent-email-change-request.component.less'],
  templateUrl: './tellent-email-change-request.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailTellentLogoComponent,
    TellentProductsFooterComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TellentEmailChangeRequestTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TellentEmailChangeRequestTemplateData>;
}

export type TellentEmailChangeRequestTemplateData = {
  avatar_url: string;
  header: string;
  subheader: string;
  body: string;
  footer: {
    text: string;
    label: string;
    href: string;
  };
  primary_cta: {
    href: string;
    label: string;
  };
};

export const TellentEmailChangeRequestTemplateMocks: TellentEmailChangeRequestTemplateData[] = [
  {
    avatar_url:
      'https://recruitee-staging.s3.eu-central-1.amazonaws.com/admins/45690/thumb_avatar_hcwhs58oldbe.jpg',
    header: 'Email change request',
    subheader: `Hello %{user_name}! 👋 We’ve received a request to change your email address. A confirmation message has been sent to your new email address.`,
    body: 'If this change hasn’t been made by you, please contact our support team.',
    footer: {
      text: 'Need help?',
      href: 'support@tellent.com',
      label: 'Contact us',
    },
    primary_cta: {
      href: 'https://tellent.com',
      label: 'Confirm change email',
    },
  },
];
